import React, { FC } from "react";

const Empty: FC = ({ children }) => {
  return <>{children}</>;
};

export default Empty;
